<app-side-top-bar [navigationItems]="navigationItems">
  <main>
    <div class="appointment-title">
      <h2>{{ name_title_date }}</h2>
    </div>
    <button type="button" class="navigate-ai-chip" (click)="navigateToAiPage()">
      <mat-icon>arrow_back</mat-icon>
      <span>Analisi AI</span>
    </button>
    @if (isMobilePortrait) {
      <div>
        <span>Gira il dispositivo per visualizzare la pagina</span>
      </div>
    }
    @if (!isMobilePortrait) {
      <section class="interview-details">
        <section class="notes-transcipt-topic">
          <header class="header">
            <div class="sections">
              <div class="{{ topicSelected }}" (click)="displayTopicSection()">
                <h2>{{ labelService.getLabel("semantic_analysis") }}</h2>
              </div>
              <div class="{{ notesSelected }}" (click)="displayNotesSection()">
                <h2>{{ labelService.getLabel("notes") }}</h2>
              </div>
            </div>
            @if (notesSelected === "selected") {
              <div class="header-buttons">
                <app-button
                  [icon]="modifyButtonText"
                  (click)="onModifyButtonClick()"
                ></app-button>
              </div>
            }
          </header>
          @if (topicSelected === "selected") {
            <div class="sub-header">
              <div class="ai-sections">
                <mat-chip
                  class="{{
                    aiSummarySelected === 'ai-section-selected'
                      ? 'chip-selected'
                      : 'chip-not-selected'
                  }}"
                  (click)="displayAiSection('AppSumm')"
                >
                  <mat-icon>summarize</mat-icon>
                  {{ "Sintesi" }}
                </mat-chip>
                <mat-chip
                  class="{{
                    aiWordcloudsSelected === 'ai-section-selected'
                      ? 'chip-selected'
                      : 'chip-not-selected'
                  }}"
                  (click)="displayAiSection('Wordclouds')"
                >
                  <mat-icon>cloud</mat-icon>
                  {{ "Wordcloud" }}
                </mat-chip>
                <mat-chip
                  class="{{
                    aiCategoriesDistributionSelected === 'ai-section-selected'
                      ? 'chip-selected'
                      : 'chip-not-selected'
                  }}"
                  (click)="displayAiSection('Categories')"
                >
                  <mat-icon>assessment</mat-icon>
                  {{ "Topic Nucleari" }}
                </mat-chip>
                <mat-chip
                  class="{{
                    aiTopicSelected === 'ai-section-selected'
                      ? 'chip-selected'
                      : 'chip-not-selected'
                  }}"
                  (click)="displayAiSection('AiTopic')"
                >
                  <mat-icon>topic</mat-icon>
                  {{ "AI Topic" }}
                </mat-chip>
              </div>
              <div class="button-group">
                @if (
                  aiSummarySelected === "ai-section-selected" && appSumm !== ""
                ) {
                  <app-button
                    [icon]="isEditing ? 'save' : 'edit'"
                    (click)="toggleEdit()"
                  ></app-button>
                }
                <button
                  mat-icon-button
                  (click)="toggleInfoPanel()"
                  aria-label="Info"
                  class="info-button"
                >
                  <mat-icon>info</mat-icon>
                </button>
                <button
                  mat-icon-button
                  (click)="downloadPDF()"
                  aria-label="Download PDF"
                  class="info-button"
                >
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </div>
          }
          <div class="table-container">
            @if (notesSelected === "selected") {
              <app-interview-notes
                [(noteText)]="appointment.appointment_notes"
                [textEditable]="hasModifyButtonBeenClicked"
              ></app-interview-notes>
            }
            @if (topicSelected === "selected") {
              <app-interview-ai-topic
                [appSumm]="appSumm"
                [isEditing]="isEditing"
                [aiSummarySelected]="aiSummarySelected"
                [aiCategoriesDistributionSelected]="
                  aiCategoriesDistributionSelected
                "
                [aiWordcloudsSelected]="aiWordcloudsSelected"
                [aiTopicSelected]="aiTopicSelected"
                [nuclearTopicsDistrEnriched]="nuclearTopicsDistrEnriched"
                [topicsForWordclouds]="topicsForWordclouds"
                [wordCloudData]="wordCloudData"
                [isLoadingAiTopic]="isLoadingAiTopic"
                [isLoadingAiWordclouds]="isLoadingAiWordclouds"
                [isLoadingAiCategoriesDistribution]="
                  isLoadingAiCategoriesDistribution
                "
                [isLoadingAiSummary]="isLoadingAiSummary"
                (appSummChange)="onSummaryChange($event)"
              ></app-interview-ai-topic>
            }
          </div>
        </section>
      </section>
    }

    @if (showInfoPanel) {
      <app-info-panel
        [infoTitle]="infoTitle"
        [infoText]="infoText"
        (close)="toggleInfoPanel()"
      ></app-info-panel>
    }
  </main>
</app-side-top-bar>
